import {LitElement, html} from "lit";
import { customElement } from "lit/decorators.js";
import { loadingAnimationStyles } from "./loading-animation.styles";

@customElement('sbk-loading-animation')
export class SbkLoadingAnimation extends LitElement {
    static get styles() {
        return loadingAnimationStyles;
    }

    render() {
        return html`
      <div class="loader">
      </div>
    `;
    }
}

